import { CSSProperties } from 'react'

const styles: { container: CSSProperties } = {
  container: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    padding: 4,
  },
}

export default styles
